import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import { pageTabHeaderTypographyProps } from "@/App/Layouts/PageBody/PageTabHeader";
import VehicleView from "@/common/components/Entity/Vehicle/View/VehicleView";
import { VehicleDamageDtoAll, VehicleDamageDtoAny } from "@/common/mapping/mappers/vehicleDamage";
import { ViewVariant } from "@/common/ts/layout";

interface Props {
  entity: VehicleDamageDtoAny;
}

export default function VehicleTabContent({ entity }: Props) {
  const entity2 = entity as VehicleDamageDtoAll;

  return (
    <PageTabContent>
      <VehicleView
        vehicleId={entity2.vehicle?.id || entity2.vehicleId}
        vehicle={undefined}
        displayProps={{
          breadcrumbs: false,
          header: false,
          actions: true,
          viewVariant: ViewVariant.Tab,
        }}
        headerProps={{
          withLink: true,
          typographyProps: pageTabHeaderTypographyProps.title,
        }}
        onDelete={null}
      />
    </PageTabContent>
  );
}
